<template>
    <div class="w-100">
        <div class="backgroundComponent" />
        <!-- <div class=""> -->
            <div class="row">


                <!-- v-if="this.visibleRange && this.visibleRange.start > 0" -->
                <!-- <div  class="arrowWrapper left col-1" @click="scroll(-1)">
                    <img class="arrowIcon h-100" src="../assets/images/fi-rr-angle-small-left.svg" alt="Left Arrow" />
                </div> -->
                <div class="col-4 p-1" v-for="(size, index) in sizes" :key="index" 
                    @click="selectSize(size)">
                    <div class="sizeTitle sizeBox text-dark"  :class="{ 'size-box-clicked': (selectedSize && (selectedSize.id === size.id)) }" >{{ size.name }}</div>
                </div>

                <div v-if="!sizes.length" class="sizeBox text-danger">
                    <span>Non Disponible</span>
                </div>

                <!-- v-if="this.visibleRange && this.sizes && this.visibleRange.end < this.sizes.length - 1" -->
                <!-- <div  class="arrowWrapper right col-1" @click="scroll(1)">
                    <img class="arrowIcon h-100" src="../assets/images/fi-rr-angle-small-right.svg" alt="Right Arrow" />
                </div> -->
            <!-- </div> -->
        </div>
    </div>
</template>
<script>
export default {
    name: "FilterSizeComponent",
    props: {
        sizes: Array,

        propSelectedSize: Object
    },
    data() {
        return {
            //visibleRange: { start: 0, end: 4000 }, 
            // Initial visible range
            
            selectedSize: null,
        };
    },

    mounted() {

        //this.selectedSize = this.propSelectedSize;
            if(this.propSelectedSize) {
            this.selectedSize = this.sizes.find(size => size.id === this.propSelectedSize.id);
            this.$emit('select-init', this.selectedSize);
        }
    },

    computed: {

    },
    methods: {
        scroll(direction) {
            const step = 1; // Number of sizes to scroll

            if (direction === 1) {
                // Scroll right
                if (this.visibleRange.end < this.sizes.length - 1) {
                    this.visibleRange.start = Math.min(this.visibleRange.start + step, this.sizes.length - 5);
                    this.visibleRange.end = Math.min(this.visibleRange.end + step, this.sizes.length - 1);
                }
            } else if (direction === -1) {
                // Scroll left
                if (this.visibleRange.start > 0) {
                    this.visibleRange.start = Math.max(this.visibleRange.start - step, 0);
                    this.visibleRange.end = Math.max(this.visibleRange.end - step, 4);
                }
            }
        },

        selectSize(size) {
            if (this.selectedSize && this.selectedSize.id == size.id) {
                this.selectedSize = null;
            } else {
                this.selectedSize = size;
            }

            this.$emit('size-selected', this.selectedSize);
        },
    },
};
</script>
  
<style scoped>
.backgroundComponent {
   /* position: absolute;*/
    height: 100%;
    width: 100%;
    top: 0%;
    right: 0%;
    bottom: 0%;
    left: 0%;
    background-color: rgba(255, 255, 255, 0.7);
}

.sizeTitle {
    /*position: relative;*/
    line-height: 22px;
}

.sizeBox {
    border: 1px solid #cbcbcb;
    box-sizing: border-box;
    height: 38px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 4px 15px;
    cursor: pointer;
    transition: border-color 0.3s; 
    font-family: 'Space Grotesk' !important;
    font-weight: bold;
}

.size-box-clicked {
    border: 2px solid #000;
    background-color: #121212; /*#F5F5F5;*/
    color: #fff !important;
}

.sizeBox:hover {
    border-color: #000;
}

.groupButtons {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    gap: 10px;
    align-items: center;
    justify-content: center;
}

.boxesWrapper {
    position: absolute;
    height: 73.08%;
    width: 92.93%;
    top: 13.46%;
    right: 3.53%;
    bottom: 13.46%;
    left: 3.53%;
}

.sizeContainer {
    /*position: relative;*/
    width: 100%;
    height: 52px;
    text-align: center;
    font-size: 14px;
    color: #121212;
    /*font-family: Inter;*/
}

.arrowWrapper {
    cursor: pointer;
}

.arrowIcon {
    width: 20px;
    height: 20px;
}
</style>
